import React from "react";
import { useEffect } from "react";
// import GridContainer from '../gridcontainer/gridconatiner';
// import Testticker from './testTicker';
// import axios from 'axios';
// import { useState } from 'react';
// import { getYoutubePlaylist } from '../api/core';
import ProgramGuide from "../epg/epg";

// import Program from '../epg/program';
const Test = () => {
  // const [tester,SetTester] = useState(null);
  useEffect(() => {
    // const playlistDetail = async (id, limit) => {
    //   /* eslint-disable no-unused-vars */
    //   const result = await getYoutubePlaylist(id, limit).then(
    //     (result) => {
    //
    //     },
    //     (error) => {
    //
    //     }
    //   );
    //   /* eslint-disable no-unused-vars */
    // };
    // playlistDetail("PLEmB2PkGA7FQg3CKU_i8Q-xkhTEaYkeB9",20);
  }, []);
  return (
    <div>
      {/* <GridContainer></GridContainer> */}

      <ProgramGuide></ProgramGuide>

      <div>
        {/* {tester?<Testticker title={tester.label_Director}></Testticker>:<></>} */}
      </div>
    </div>
  );
};

export default Test;
